import { ProductCategoryType } from '@openeducation/oe-rn-shared-types';

import LevelsMetadataDao from '../dao/levels-metadata.dao';
import type { LevelsMetadata } from '../interfaces';
import type { Environment } from '../interfaces/environment';

export abstract class LevelsMetadataService {
  static getLevelsMetadata(
    env: Environment,
    productCategory?: ProductCategoryType
  ): Promise<LevelsMetadata[]> {
    return LevelsMetadataDao.getLevelsMetadata(env, productCategory);
  }
}
